import Input from "@mui/joy/Input"
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import { Dispatch, SetStateAction, useEffect, useState } from "react"
import Box from "@mui/joy/Box";

const YAML_TEMPLATE = `
# Tiny Tapeout project information
project:
  title:        "$$TITLE$$"      # Project title
  author:       "$$AUTHOR$$"      # Your name
  discord:      ""      # Your discord username, for communication and automatically assigning you a Tapeout role (optional)
  description:  "$$DESCRIPTION$$; Built on play.spade-lang.org"      # One line description of what your project does
  language:     "Spade" # other examples include SystemVerilog, Amaranth, VHDL, etc
  clock_hz:     10000       # Clock frequency in Hz (or 0 if not applicable)

  # How many tiles your design occupies? A single tile is about 167x108 uM.
  tiles: "1x1"          # Valid values: 1x1, 1x2, 2x2, 3x2, 4x2, 6x2 or 8x2

  # Your top module name must start with "tt_um_". Make it unique by including your github username:
  top_module:  "$$PROJECT_NAME$$"

  # List your project's source files here.
  # Source files must be in ./src and you must list each source file separately, one per line.
  # Don't forget to also update PROJECT_SOURCES in test/Makefile.
  source_files:
    - "spade.sv"

# The pinout of your project. Leave unused pins blank. DO NOT delete or add any pins.
# This section is for the datasheet/website. Use descriptive names (e.g., RX, TX, MOSI, SCL, SEG_A, etc.).
pinout:
  # Inputs
  ui[0]: "TODO"
  ui[1]: "TODO"
  ui[2]: "TODO"
  ui[3]: "TODO"
  ui[4]: "TODO"
  ui[5]: "TODO"
  ui[6]: "TODO"
  ui[7]: "TODO"

  # Outputs
  uo[0]: "TODO"
  uo[1]: "TODO"
  uo[2]: "TODO"
  uo[3]: "TODO"
  uo[4]: "TODO"
  uo[5]: "TODO"
  uo[6]: "TODO"
  uo[7]: "TODO"

  # Bidirectional pins
  uio[0]: "UNUSED"
  uio[1]: "UNUSED"
  uio[2]: "UNUSED"
  uio[3]: "UNUSED"
  uio[4]: "UNUSED"
  uio[5]: "UNUSED"
  uio[6]: "UNUSED"
  uio[7]: "UNUSED"

# Do not change!
yaml_version: 6
`

const PROJECT_NAME_RE = new RegExp(/entity (tt_um_\w+)/g)

export function TTMetadata({ user, onYamlChange, spadeCode }: { user: string, onYamlChange: (arg0: string) => any, spadeCode: string }) {
  const [title, setTitle] = useState(localStorage.getItem("project_title"))
  useEffect(() => { localStorage.setItem("project_title", title) }, [title])
  const [description, setDescription] = useState(localStorage.getItem("project_description"))
  useEffect(() => { localStorage.setItem("project_description", description) }, [description])

  const projectNames = [...spadeCode.matchAll(PROJECT_NAME_RE)].map((match) => match[1])
  
  useEffect(() => {
    if (projectNames.length == 1) {
      onYamlChange(YAML_TEMPLATE
        .replaceAll("$$TITLE$$", title)
        .replaceAll("$$DESCRIPTION$$", description)
        .replaceAll("$$PROJECT_NAME$$", projectNames[0])
        .replaceAll("$$AUTHOR$$", user)
      )
    } else {
      onYamlChange(null)
    }
  }, [title, description, projectNames])

  return <Box>
    <FormControl>
      <FormLabel>Project title*</FormLabel>
      <Input size="sm" value={title} onChange={(e) => { setTitle(e.target.value) }} />
    </FormControl>
    <FormControl>
      <FormLabel>Project description</FormLabel>
      <Input size="sm" value={description} onChange={(e) => { setDescription(e.target.value) }} />
    </FormControl>
    {
      projectNames.length == 0
        ? <p>Expected an entity called <code>tt_um_...</code> but did not find one</p>
        : (
          projectNames.length > 1
            ? <p>Found multiple modules named <code>tt_um_...</code></p>
            : <p>Project name found in code: <code>{projectNames[0]}</code></p>
        )
    }
  </Box>
}
